import React, { VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ThemePageCard } from '../pages/Top';

type Props = ThemePageCard & {
  className?: string;
};

const Card: VFC<Props> = ({ headline, slug, headerImageUrl, className }) => {
  const classes = useStyles();
  return (
    <a href={`/theme/${slug}`} className={clsx(classes.root, className)}>
      <div className={classes.thumbnailWrapper}>
        {headerImageUrl ? (
          <img
            src={headerImageUrl}
            alt={headline}
            className={classes.thumbnail}
          />
        ) : (
          <div className={classes.noImage} />
        )}
      </div>
      <p className={classes.title}>{headline}</p>
    </a>
  );
};

export default Card;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    textDecoration: 'none',
    color: '#333',
    '&:hover': {
      opacity: 0.8,
    },
  },
  thumbnailWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '97.9%', // 282/288 aspect ratio
    borderRadius: 4,
    overflow: 'hidden',
  },
  thumbnail: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 4,
  },
  noImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#eee',
    borderRadius: 4,
  },
  title: {
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    fontSize: theme.typography.pxToRem(14),
    height: `calc(${theme.typography.pxToRem(14)} * ${
      theme.typography.body1.lineHeight
    } * 2)`,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
      height: `calc(${theme.typography.pxToRem(16)} * ${
        theme.typography.body1.lineHeight
      } * 2)`,
    },
    margin: 0,
  },
}));
